import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'
import academicLevelTypes from 'helpers/enums/academicLevelTypes'
import userAcademicLevel from 'redux/selectors/user/academic_level_selector'
import userBadgeSelector from 'redux/selectors/user/user_badge_selector'
import userFullNameSelector from 'redux/selectors/user/user_full_name_selector'

const getUserData = state => state.user.data
const getMyAccountData = state => state.myAccount

const defaultData = {
	id: 0,
	name: '',
	schoolName: '',
	showUpgradeButton: false,
	showGetSchoolButton: false,
	featuresTrial: false,
	badgeColor: '',
	badgeText: '',
	userType: '',
	storagePercent: 0,
	storageText: '',
	maxUploadImageSize: 0,
	zipCode: '',
	image: '',
	referral: false,
	intercomIO: false,
}

const baseViewSelector = createSelector(
	[ getUserData, getMyAccountData, userBadgeSelector, userAcademicLevel, userFullNameSelector ],
	(userData, myAccountData, userBadge, userAcademicLevel, userFullName) => {
		let userMyAccountData = {}
		if (userData.account) {
			userMyAccountData.userId = userData.userId
			const productId = parseInt(userData.productId)
			userMyAccountData.name = userFullName
			userMyAccountData.intercomIO = userData.intercomIO
			userMyAccountData.schoolName = userData.account.schoolName || ''
			userMyAccountData.showUpgradeButton = productId === 1
			userMyAccountData.showGetSchoolButton = productId === 2 || productId === 6 || productId === 7
			if (userData.account.featuresTrial) {
				userMyAccountData.featuresTrial = {}
				userMyAccountData.featuresTrial.textBefore = ''
				userMyAccountData.featuresTrial.text = userData.account.featuresTrial.text
				userMyAccountData.featuresTrial.textAfter = ''
				if (userData.account.featuresTrial.type == 1) {
					userMyAccountData.featuresTrial.textBefore = userData.account.featuresTrial.textBefore+' '
					userMyAccountData.featuresTrial.textAfter = ' '+userData.account.featuresTrial.textAfter
				}
			}
			if (userData.account.referral) {
				userMyAccountData.referral = {}
				userMyAccountData.referral.link = userData.account.referral.link
				userMyAccountData.referral.text = localize('my_account_menu_upgrade_trial_link_free_gold')
			}

			userMyAccountData.badgeText = userBadge.badgeTitle
			userMyAccountData.badgeProduct = userBadge.badgeProduct
			userMyAccountData.image = userData.image
			userMyAccountData.maxUploadImageSize = localize('my_account_profile_header_image_tooltip') + userData.maxUploadImageSize + localize('my_account_profile_header_image_mb')
		} else {
			userMyAccountData = defaultData
		}

		if (myAccountData.data) {
			userMyAccountData.storagePercent = myAccountData.data.percentStorage
			userMyAccountData.storageText = localize('my_account_base_storage_you_have_used') + ' ' + myAccountData.data.usedStorage + ' ' + localize('global_of') + ' ' + myAccountData.data.maxStorage
			userMyAccountData.zipCode = myAccountData.data.zipCode
		}

		const isHigherEdUser = userAcademicLevel === academicLevelTypes.HIGHER_ED

		return {
			userData: userMyAccountData,
			showProfileImageUploading: myAccountData.showProfileImageUploading,
			shouldShowNotificationsButton: !isHigherEdUser,
		}
	}
)

export default baseViewSelector
